export enum ExportState {
  EXPORT_REQUESTED = 'REQUESTED',
  EXPORT_GENERATED = 'GENERATED',
  EXPORT_DOWNLOADED = 'DOWNLOADED',
  EXPORT_FAILED = 'FAILED'
}
